import React from 'react'

const Matrix = () => {
  return (
    <div>
      <h1>Matrix</h1>
    </div>
  )
}

export default Matrix
